import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const dispatchAdviceListTodo = createAsyncThunk('dispatchAdviceList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `despatch-advice`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'deliveryDate': data?.deliveryDate && moment(data?.deliveryDate).format('YYYY-MM-DD'),
                'deliveryStatus': data?.deliveryStatus,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const dispatchAdviceListSlice = createSlice({
    name: 'dispatchAdviceList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(dispatchAdviceListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(dispatchAdviceListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default dispatchAdviceListSlice.reducer; 